import { getLoaderEndpoint } from "@app/framework/loader";
import { pageHead } from "@app/framework/meta";
import { InvestorGovernanceDocumentsPage } from "@modules/investor/pages";
import { getGovernanceAndRegulatoryDocuments } from "@modules/investor/services";
import { DocumentFile } from "@modules/investor/types";
import { trans } from "@mongez/localization";
import { LoaderFunction, LoaderFunctionArgs } from "@remix-run/node";
import { MetaFunction, useLoaderData } from "@remix-run/react";

export const loader: LoaderFunction = async ({
  request,
}: LoaderFunctionArgs) => {
  const { http, success, catchErrors } = await getLoaderEndpoint(request);

  try {
    const documents = await getGovernanceAndRegulatoryDocuments(http);

    return success(documents);
  } catch (error: any) {
    return catchErrors(error);
  }
};

export default function GovernanceAndRegulatoryDocuments() {
  const documents = useLoaderData<DocumentFile[]>();
  return <InvestorGovernanceDocumentsPage documents={documents} />;
}

export const meta: MetaFunction = ({ data }: any) => {
  return pageHead({
    title: data?.metaData?.title || trans("governanceDocuments"),
    description:
      data?.metaData?.description ||
      trans("governanceAndRegulatory.description"),
  });
};
